<script>
import {
  memberListAgentadminComputed,
  memberListAgentadminMethods,
} from '@state/helpers/member-list-agentadmin'
import { GENDER } from '@utils/constant'
import SearchPayload from '@utils/searchPayload'
import ChartRegister from './chart-register.vue'
export default {
  components: { ChartRegister },
  data() {
    return {
      showOverview: false,
      GENDER: GENDER,
      searchBody: new SearchPayload.Builder().build(),
    }
  },
  computed: {
    ...memberListAgentadminComputed,
  },
  created() {
    this.getOverView()
  },
  methods: {
    ...memberListAgentadminMethods,
    getOverView() {
      this.fetchingOverviewMember()
    },
    filterWithGender(v) {
      const gender = v === this.GENDER[0] ? { gender: 0 } : { gender: 1 }
      this.showOverview = false
      this.$emit('search-gender', gender)
    },
    filterWithStatus(indexStatus) {
      this.showOverview = false
      this.$emit('search-status', indexStatus)
    },
    filterWithAge(age) {
      this.showOverview = false
      this.$emit('search-age', age)
    },
  },
}
</script>

<template>
  <BaseCardDetail title="Overview" :form-collapsed="showOverview">
    <template v-slot:header-action>
      <CButton
        variant="ghost"
        :class="{ rotate: showOverview }"
        @click="showOverview = !showOverview"
      >
        <font-awesome-icon icon="chevron-down" />
      </CButton>
    </template>
    <CRow>
      <CCol sm="5">
        <CCard>
          <CCardHeader color="dark" class="card-header-feeline ">
            <h5 class="m-0 card-header-title-feeline">ユーザ内訳</h5>
          </CCardHeader>
          <CCardBody class="p-0">
            <div
              v-for="item in getOverviewMember"
              :key="item.key"
              class="border-bottom p-4"
            >
              <div class="mb-2">{{ item.key }}</div>
              <CRow v-for="v in item.value" :key="v.label" class="mb-2">
                <template v-if="v.label === GENDER[0] || v.label === GENDER[1]">
                  <CCol sm="3" class="progress-group-text-feeline">
                    {{ v.label }}
                  </CCol>
                  <CCol sm="9" @click="filterWithGender(v.label)">
                    <CProgress
                      :show-percentage="true"
                      size="sm"
                      :value="v.value"
                      :color="v.color"
                      show-value
                      style="height:16px;"
                    />
                  </CCol>
                </template>
                <template v-else-if="v.indexStatus">
                  <CCol sm="3" class="progress-group-text-feeline">
                    {{ v.label }}
                  </CCol>
                  <CCol sm="9" @click="filterWithStatus(v.indexStatus)">
                    <CProgress
                      :show-percentage="true"
                      size="sm"
                      :value="v.value"
                      :color="v.color"
                      show-value
                      style="height:16px;"
                    />
                  </CCol>
                </template>
                <template v-else>
                  <CCol sm="3" class="progress-group-text-feeline">
                    {{ v.label }}
                  </CCol>
                  <CCol sm="9" @click="filterWithAge(v.age)">
                    <CProgress
                      :show-percentage="true"
                      size="sm"
                      :value="v.value"
                      :color="v.color"
                      show-value
                      style="height:16px;"
                    />
                  </CCol>
                </template>
              </CRow>
            </div>
          </CCardBody>
        </CCard>
      </CCol>
      <CCol sm="7">
        <CCard>
          <CCardHeader color="dark" class="card-header-feeline">
            <h5 class="m-0 card-header-title-feeline">登録ユーザ数</h5>
          </CCardHeader>
          <CCardBody>
            <ChartRegister />
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </BaseCardDetail>
</template>

<style lang="scss" scoped>
::v-deep .card-header-feeline {
  font-weight: 700;
  line-height: 1.2;
  color: #fff;
}

::v-deep .card-header-title-feeline {
  font-weight: 700;
}

::v-deep .rotate {
  transform: rotate(180deg);
}

::v-deep .progress-group-text-feeline {
  font-size: 0.765625rem;
  color: #73818f;
}

::v-deep .progress {
  cursor: pointer;
  background-color: #c8ced3;

  &:hover {
    border-color: #e0eeca;
    outline: 0;
    -webkit-box-shadow: 0 0 0 0.3rem rgb(168 207 106 / 25%);
    box-shadow: 0 0 0 0.3rem rgb(168 207 106 / 25%);
  }
}

::v-deep .progress-bar {
  overflow: visible !important;
}
::v-deep .bg-men {
  background-color: #63c2de !important;
}
::v-deep .bg-woman {
  background-color: #f86c6b !important;
}
::v-deep .bg-status {
  background-color: #cfa65f !important;
}
</style>
